export enum DocumentType {
	SocialContract,

	RentalContract,

	EntryInspection,

	IncomeTaxReceipt,

	PersonalIncomeTax,

	IncomeDocument,

	CreditCardInvoice,

	IdentityDocument,

	SpcScoreAnalysisDocument,

	Holerith,

	BankStatement,

	InssVoucher,

	ApprovalLetter,

	TermsAndConditions,

	FireInsurancePolicy,

	FireInsuranceProposal,

	GeneralTermsAndConditions,

	RentalContractAddendum,

	TermsAndConditionsSigned,

	KeyDeliveryTerm,

	ExitInspection,

	SuretyBondAddendum,

	Invoice,

	InvoiceBill,

	InvoiceBudget,

	DebtConfessionAgreement,

	PaymentReceipt,

	ExtrajudicialNotification,

	Image,

	ExonerationNotification,

	ExonerationNotificationFiador,

	DebtConfessionAgreementSigned,

	ExtrajudicialNotificationCollection,

	DischargeAgreement,

	CurrentGuarantorTermsAndConditions,

	// 35 e 36 (apólice e boleto do seguro fiança) existem no back; o front ainda não os lista.

	// Documentos do Locador (ENG-568), com número EXPLÍCITO igual ao do back: o banco grava o número.
	// A faixa começa acima do forno/staging, onde 34–36 são da portabilidade e do seguro fiança
	// (decisão de 20/10/2026). O dono destes documentos é sempre a RAIZ da cadeia do contrato (DEC-20).
	LessorIdentityDocument = 37,

	LessorProofOfAddress = 38,

	LessorSocialContract = 39,

	LessorResponsibleIdentityDocument = 40,

	LessorResponsibleProofOfAddress = 41,

	// Procuração do Locador (ENG-568, M4). Dona: a ocorrência. A assinada substitui a enviada.
	LessorPowerOfAttorney = 42,

	LessorPowerOfAttorneySigned = 43,

	/**
	 * Termo de Parceria enviado à ClickSign no cadastro do parceiro pelo link de lead (ENG-619). Mesmos
	 * números da API, explícitos: 34 a 43 já são da portabilidade, do seguro fiança e do Locador no forno.
	 */
	PartnershipTerm = 44,

	/** Termo de Parceria assinado, devolvido pela ClickSign. */
	PartnershipTermSigned = 45,
}

export const DocumentTypeNames = [
	{ value: 'SSP', label: 'SSP: Secretaria de Segurança Pública do Estado' },
	{
		value: 'Cartório Civil',
		label: 'Cartório Civil: Emite registro de nascimento, casamento, óbitos etc.',
	},
	{
		value: 'Polícia Federal',
		label: 'Polícia Federal: Órgão responsável pela emissão de passaporte e outros serviços',
	},
	{
		value: 'DETRAN',
		label:
			'DETRAN: Emissão de CNH (Carteira Nacional de Habilitação), CRLV (Certificado de Registro e Licenciamento de Veículos), etc.',
	},
	{ value: 'ABNC', label: 'ABNC: Academia Brasileira de Neurocirurgia' },
	{
		value: 'CGPI',
		label: 'CGPI/DUREX/DPF: Coordenação Geral de Polícia de Imigração da Polícia Federal',
	},
	{ value: 'CGPI', label: 'CGPI: Coordenação-Geral de Privilégios e Imunidades' },
	{
		value: 'CGPMAF',
		label: 'CGPMAF: Coordenadoria Geral de Polícia Marítima, Aeronáutica e de Fronteiras',
	},
	{ value: 'CNIG', label: 'CNIG: Conselho Nacional de Imigração' },
	{ value: 'CNT', label: 'CNT: Confederação Nacional de Transporte' },
	{ value: 'COREN', label: 'COREN: Conselho Regional de Enfermagem' },
	{ value: 'CORECON', label: 'CORECON: Conselho Regional de Economia' },
	{ value: 'CRA', label: 'CRA: Conselho Regional de Administração' },
	{ value: 'CRAS', label: 'CRAS: Centro de Referência de Assistência Social' },
	{ value: 'CRB', label: 'CRB: Conselho Regional de Biblioteconomia' },
	{ value: 'CRC', label: 'CRC: Conselho Regional de Contabilidade' },
	{ value: 'CRE', label: 'CRE: Conselho Regional de Estatística' },
	{ value: 'CREA', label: 'CREA: Conselho Regional de Engenharia e Agronomia' },
	{ value: 'CRECI', label: 'CRECI: Conselho Regional de Corretores de Imóveis' },
	{ value: 'CREFIT', label: 'CREFIT: Conselho Regional de Fisioterapia e Terapia Ocupacional' },
	{ value: 'CRESS', label: 'CRESS: Conselho Regional de Serviço Social' },
	{ value: 'CRF', label: 'CRF: Conselho Regional de Farmácia' },
	{ value: 'CRM', label: 'CRM: Conselho Regional de Medicina' },
	{ value: 'CRN', label: 'CRN: Conselho Regional de Nutrição' },
	{ value: 'CRO', label: 'CRO: Conselho Regional de Odontologia' },
	{ value: 'CRP', label: 'CRP: Conselho Regional de Psicologia' },
	{ value: 'CRPRE', label: 'CRPRE: Conselho Regional de Profissionais de Relações Públicas' },
	{ value: 'CRQ', label: 'CRQ: Conselho Regional de Química' },
	{ value: 'CRRC', label: 'CRRC: Conselho Regional de Representantes Comerciais' },
	{ value: 'CRMV', label: 'CRMV: Conselho Regional de Medicina Veterinária' },
	{ value: 'CSC', label: 'CSC: Carteira Sede Carpina de Pernambuco' },
	{ value: 'CTPS', label: 'CTPS: Carteira de Trabalho e Previdência Social' },
	{ value: 'DIC', label: 'DIC: Diretoria de Identificação Civil' },
	{ value: 'DIREX', label: 'DIREX: Diretoria-Executiva' },
	{ value: 'DPMAF', label: 'DPMAF: Divisão de Polícia Marítima, Área e de Fronteiras' },
	{ value: 'DPT', label: 'DPT: Departamento de Polícia Técnica Geral' },
	{ value: 'DST', label: 'DST: Programa Municipal DST/Aids' },
	{ value: 'FGTS', label: 'FGTS: Fundo de Garantia do Tempo de Serviço' },
	{ value: 'FIPE', label: 'FIPE: Fundação Instituto de Pesquisas Econômicas' },
	{ value: 'FLS', label: 'FLS: Fundação Lyndolpho Silva' },
	{ value: 'GOVGO', label: 'GOVGO: Governo do Estado de Goiás' },
	{ value: 'I CLA', label: 'I CLA: Carteira de Identidade Classista' },
	{ value: 'IFP', label: 'IFP: Instituto Félix Pacheco' },
	{ value: 'IGP', label: 'IGP: Instituto Geral de Perícias' },
	{
		value: 'IICCECF',
		label:
			'IICCECF/RO: Instituto de Identificação Civil e Criminal Engrácia da Costa Francisco de Rondônia',
	},
	{ value: 'IIMG', label: 'IIMG: Inter-institutional Monitoring Group' },
	{ value: 'IML', label: 'IML: Instituto Médico-Legal' },
	{ value: 'IPC', label: 'IPC: Índice de Preços ao Consumidor' },
	{ value: 'IPF', label: 'IPF: Instituto Pereira Faustino' },
	{ value: 'MAE', label: 'MAE: Ministério da Aeronáutica' },
	{ value: 'MEX', label: 'MEX: Ministério do Exército' },
	{ value: 'MMA', label: 'MMA: Ministério da Marinha' },
	{ value: 'OAB', label: 'OAB: Ordem dos Advogados do Brasil' },
	{ value: 'OMB', label: 'OMB: Ordens dos Músicos do Brasil' },
	{ value: 'PCMG', label: 'PCMG: Polícia Civil do Estado de Minas Gerais' },
	{ value: 'PMMG', label: 'PMMG: Polícia Militar do Estado de Minas Gerais' },
	{ value: 'POF', label: 'POF ou DPF: Polícia Federal' },
	{ value: 'POM', label: 'POM: Polícia Militar' },
	{ value: 'SDS', label: 'SDS: Secretaria de Defesa Social (Pernambuco)' },
	{ value: 'SNJ', label: 'SNJ: Secretaria Nacional de Justiça / Departamento de Estrangeiros' },
	{ value: 'SECC', label: 'SECC: Secretaria de Estado da Casa Civil' },
	{
		value: 'SEJUSP',
		label: 'SEJUSP: Secretaria de Estado de Justiça e Segurança Pública – Mato Grosso',
	},
	{ value: 'SES', label: 'SES ou EST: Carteira de Estrangeiro' },
	{ value: 'SESP', label: 'SESP: Secretaria de Estado da Segurança Pública do Paraná' },
	{ value: 'SJS', label: 'SJS: Secretaria da Justiça e Segurança' },
	{ value: 'SJTC', label: 'SJTC: Secretaria da Justiça do Trabalho e Cidadania' },
	{ value: 'SJTS', label: 'SJTS: Secretaria da Justiça do Trabalho e Segurança' },
	{ value: 'SPTC', label: 'SPTC: Secretaria de Polícia Técnico-Científica' },
];
